import React from 'react';

export const AiWand = () => (
	<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.00004 3.73325L3.33337 4.66659L4.26671 2.99992L3.33337 1.33325L5.00004 2.26659L6.66671 1.33325L5.73337 2.99992L6.66671 4.66659L5.00004 3.73325ZM13 10.2666L14.6667 9.33325L13.7334 10.9999L14.6667 12.6666L13 11.7333L11.3334 12.6666L12.2667 10.9999L11.3334 9.33325L13 10.2666ZM14.6667 1.33325L13.7334 2.99992L14.6667 4.66659L13 3.73325L11.3334 4.66659L12.2667 2.99992L11.3334 1.33325L13 2.26659L14.6667 1.33325ZM8.89337 8.51992L10.52 6.89325L9.10671 5.47992L7.48004 7.10659L8.89337 8.51992ZM9.58004 4.85992L11.14 6.41992C11.4 6.66659 11.4 7.09992 11.14 7.35992L3.36004 15.1399C3.10004 15.3999 2.66671 15.3999 2.42004 15.1399L0.860039 13.5799C0.600039 13.3333 0.600039 12.8999 0.860039 12.6399L8.64004 4.85992C8.90004 4.59992 9.33337 4.59992 9.58004 4.85992Z"
			fill="url(#paint0_linear_19_220)" />
		<defs>
			<linearGradient id="paint0_linear_19_220" x1="14.987" y1="7.785" x2="0.665039" y2="7.785"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#314FEB" />
				<stop offset="0.510417" stopColor="#334FEB" />
				<stop offset="1" stopColor="#2D4EEC" />
			</linearGradient>
		</defs>
	</svg>
);